import { Component, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NavigationDirections } from '../../types';
import { MatPrefix, MatSuffix } from '@angular/material/input';
import { NgClass } from '@angular/common';

@Component({
  imports: [MatIconModule, MatPrefix, NgClass, MatSuffix],
  selector: 'wcg-link-tag',
  styles: `
    @use '../../../../shared/styles/index.scss';
    .link {
      &__disable-anchor {
        pointer-events: none;
        cursor: not-allowed;
        color: theme('colors.blue-grey.10');
      }

      &__anchor-tag {
        @extend %is-routerlink-active;
        text-decoration: none;
        border: none;
      }
    }
  `,
  template: `
    <a
      href="#"
      (click)="handleNavigation.emit(direction()); $event.preventDefault()"
      class="items-center align-middle flex link__anchor-tag"
      [ngClass]="[
        selectNoneClass() && isDisabled() ? selectNoneClass() : '',
        isDisabled() ? 'link__disable-anchor' : '',
      ]"
    >
      @if (iconPosition() === 'prefix') {
        <mat-icon fontSet="material-icons-outlined" matPrefix>{{
          iconText()
        }}</mat-icon>
      }

      {{ label() }}

      @if (iconPosition() === 'suffix') {
        <mat-icon fontSet="material-icons-outlined" matSuffix>{{
          iconText()
        }}</mat-icon>
      }
    </a>
  `,
})
export class LinkTagComponent {
  label = input<string>('');
  iconText = input<string>('');
  direction = input<'back-to-all' | 'previous' | 'next'>('back-to-all');
  iconPosition = input<'prefix' | 'suffix'>('suffix');
  isDisabled = input<boolean>(false);
  selectNoneClass = input<string>('');

  handleNavigation = output<NavigationDirections>();
}
